<template>
  <div>
    <v-layout class="mx-2 mt-4" align-center>
      <p class="headline">Fotos</p>
    </v-layout>
    <media-content-wrapper
      hideSearchbar
      :cardBreakpoints="'xs6 sm3 md2 lg3'"
      :pageSize="'xs12'"
      :items="orderedImages"
      :emptyListMessage="'Nenhuma imagem cadastrada...'"
    >
      <template v-slot:content="slotProps">
        <content-image
          :image="slotProps.item"
          @click="handleImageClick($event)"
          @delete="deleteFile($event)"
          @update="updateImages($event)"
          :deletingFile="errorDialog ? null: deletingFile"
        />
      </template>

      <template v-slot:dialog>
        <ImageGalleryDialog
          :show="showImageGallery"
          :continuous="continuousCarousel"
          :currentIndex="imageGalleryIndex"
          :images="images"
          @changedIndex="changedIndex"
          @closed="showImageGallery = false"
        />
      </template>
    </media-content-wrapper>
    <error-dialog
      v-if="errorDialog && deletingFile"
      :title="'Erro'"
      :enabled="errorDialog"
      :dialogColor="'error'"
      :confirmationButtonColor="'error'"
      :confirmationButtonMessage="'Tentar novamente'"
      :confirmationMessage="errorDialogMessage"
      @abort="errorDialogAction(false)"
      @confirm="errorDialogAction(true)"
    />
    <v-snackbar v-model="snackbar" :color="'primary'">
      A descrição da imagem foi atualizada.
      <v-btn text @click="snackbar = false">Fechar</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import MediaContentWrapper from "@/components/templates/MediaContentWrapper.vue";
import ImageGalleryDialog from "./Dialog.vue";
import ContentImage from "./ContentImage.vue";
import filesDeletion from '@/mixins/filesDeletion.js'
import { updateContent } from "@/firebase/api/content";
import ErrorDialog from "@/components/templates/ConfirmationDialog";

export default {
  components: { ContentImage, ImageGalleryDialog, MediaContentWrapper, ErrorDialog },
  mixins: [filesDeletion],
  data: () => ({
    showImageGallery: false,
    imageGalleryIndex: 0,
    continuousCarousel: false,
    snackbar: false,
  }),
  props: {
    images: Array
  },
  computed: {
    orderedImages() {
      const imagesCopy = this.images.slice().filter(image => image.title);
      imagesCopy.sort((a, b) => a.title.localeCompare(b.title));
      return imagesCopy;
    },
  },
  methods: {
    handleImageClick(index) {
      this.imageGalleryIndex = index;
      this.showImageGallery = true;
    },
    changedIndex(index) {
      this.imageGalleryIndex = index;
    },
    updateImages(updatedImage) {
      const { chapterID, contentID } = this.$route.params;
      const mapper = image => image.title === updatedImage.title ? updatedImage : image
      const images = this.images.map(mapper)
      updateContent(chapterID, contentID, { images })
      this.snackbar = true
    },
  }
};
</script>
